
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import imModal from './imModal'
import modifyPrices from './modifyPrices'
import skuInvolveEdit from './skuInvolve/edit'
import imUpload from '@/components/Upload/imUpload'
import { encrypt } from '@/utils/secret'
import { UPLOAD_COMMON_TYPE } from '@/enum/uploadType'
import { copyToClip } from '~/utils/index'
export default {
    components: { imModal, imUpload, modifyPrices, skuInvolveEdit },
    data () {
        const validatePaymentAccountTwo = (_, value, callback) => {
            if (value === '' || value === null) {
                callback(new Error('请输入确认收款账户'))
            } else if (this.paymentInfoForm.paymentAccountOne !== value) {
                callback(new Error('两次输入不一致'))
            } else {
                callback()
            }
        }
        const validatePass = (_, value, callback) => {
            if (this.sellerInfoForm.sellerCollectAccountType == 1 || this.paymentInfoForm.sellerCollectAccountType == 1) {
                if (value === '' || value === null) {
                    callback(new Error('请输入支付宝账户'))
                } else {
                    callback()
                }
            } else if (value === '' || value === null) {
                callback(new Error('请输入持卡人本人银行卡号'))
            } else {
                callback()
            }
        }
        const validatePassCopy = (_, value, callback) => {
            if (this.paymentInfoForm.paymentType == 1 || this.paymentInfoForm.paymentType == 1) {
                if (value === '' || value === null) {
                    callback(new Error('请输入支付宝账户'))
                } else if (this.paymentInfoForm.paymentAccount != value) {
                    callback(new Error('两次输入不一致'))
                } else {
                    callback()
                }
            } else if (value === '' || value === null) {
                callback(new Error('请输入持卡人本人银行卡号'))
            } else if (this.paymentInfoForm.paymentAccount != value) {
                callback(new Error('两次输入不一致'))
            } else {
                callback()
            }
        }
        const validateInfo = (_, value, callback) => {
            const reg = /^(?:(?:\+|00)86)?1[3-9]\d{9}$/
            const regEmail = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/
            if (value === '' || value === null) {
                callback(new Error('请输入换绑手机号或邮箱'))
            } else if (value.includes('@')) {
                if (!regEmail.test(value)) {
                    callback(new Error('请输入正确的手机号或邮箱'))
                } else {
                    callback()
                }
            } else if (!reg.test(value)) {
                callback(new Error('请输入正确的手机号或邮箱'))
            } else {
                callback()
            }
        }
        const validateValue = (_, value, callback) => {
            if (this.goodsCardLabelFrom.fieldType == 'SECTION') {
                // 数字校验
                if (value === '' || value === null) {
                    callback(new Error('请输入价格'))
                } else if (!/(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/.test(value)) {
                    callback(new Error('请输入有效价格'))
                } else if (value >= 99999999) {
                    callback(new Error('超过最大金额'))
                } else {
                    callback()
                }
            } else if (this.goodsCardLabelFrom.fieldType == 'TEXT') {
                // 文本校验
                if (value === '' || value === null) {
                    callback(new Error('请输入'))
                } else {
                    callback()
                }
            }
        }
        return {
            query: '',
            UPLOAD_COMMON_TYPE,
            rule: {
                sellerPhone: [
                    { required: true, message: '请输入联系手机号', trigger: 'blur' },
                    {
                        pattern: /^(?:(?:\+|00)86)?1[3-9]\d{9}$/,
                        message: '请输入正确的联系手机',
                        trigger: 'blur'
                    }
                ],
                buyerPhone: [
                    { required: true, message: '请输入联系手机号', trigger: 'blur' },
                    {
                        pattern: /^(?:(?:\+|00)86)?1[3-9]\d{9}$/,
                        message: '请输入正确的联系手机',
                        trigger: 'blur'
                    }
                ],
                sellerGameAccount: [{ required: true, message: '请输入游戏账号', trigger: 'blur' }],
                accountSource: [{ required: true, message: '账号来源', trigger: 'change' }],
                sellerQq: [{ required: true, message: '请输入联系QQ号', trigger: 'blur' }],
                sellerWx: [{ required: true, message: '请输入联系微信号', trigger: 'blur' }],
                buyerQq: [{ required: true, message: '请输入联系QQ号', trigger: 'blur' }],
                buyerWx: [{ required: true, message: '请输入联系微信号', trigger: 'blur' }],
                sellerCollectAccountType: [{ required: true, message: '请选择收款账户类型', trigger: 'change' }],
                paymentType: [{ required: true, message: '请选择收款账户类型', trigger: 'change' }],
                sellerRealName: [{ required: true, message: '请输入真实姓名', trigger: 'blur' }],
                sellerCollectAccount: [{ required: true, validator: validatePass, trigger: 'blur' }],
                paymentAccount: [{ required: true, validator: validatePass, trigger: 'blur' }],
                confirmPaymentAccount: [{ required: true, validator: validatePassCopy, trigger: 'blur' }],
                bankName: [{ required: true, message: '请输入银行名称', trigger: 'blur' }],
                gameAccountBindPhone: [{ required: true, validator: validateInfo, trigger: 'blur' }],
                realName: [{ required: true, message: '请输入真实姓名', trigger: 'blur' }],
                value: [{ required: true, validator: validateValue, trigger: 'blur' }],
                cancelReasonId: [{ required: true, message: '请选择取消原因', trigger: 'change' }],
                radioValue: [{ required: true, message: '请选择', trigger: 'change' }],
                checkboxValue: [{ required: true, message: '请选择', trigger: 'change' }],
                realNameOne: [{ required: true, message: '请输入收款人姓名', trigger: 'blur' }],
                paymentAccountOne: [{ required: true, message: '请输入收款账户', trigger: 'blur' }],
                paymentAccountTwo: [{ required: true, validator: validatePaymentAccountTwo, trigger: 'blur' }]
            }, // 检验
            accountSourceModel: false, // 账号来源模态窗显示状态
            recycleBargainingModel: false,
            expeditingLaunch: false,
            afterSalesOrdersDialog: false,
            buyerSellerLinkMsg: false,
            accountSourceList: [], // 下拉
            accountSourceForm: {
                sellerGameAccount: null, // 来源
                accountSource: 'ORIGINAL_USER', // 来源
                orderId: null
            }, // 账号来源表单
            sellerInfoModelTitle: '',
            sellerInfoModel: false, // 买卖家信息收集模态窗显示状态
            sellerInfoForm: {
                sellerCollectAccountType: null, // 支付类型
                sellerPhone: null, // 联系人收集
                sellerQq: null, // 联系人QQ
                sellerWx: null, // 联系人微信
                sellerRealName: null, // 实名
                bankName: null, // 银行名称
                sellerCollectAccount: null, // 银行卡号 or 支付宝号
                idToken: null, // 校验是否提交过
                jumpStatus: false, // 跳过状态
                orderId: null
            }, // 买卖家信息收集表单
            buyerInfoForm: {
                buyerPhone: null, // 联系人收集
                buyerQq: null, // 联系人QQ
                buyerWx: null, // 联系人微信
                gameAccountBindPhone: null, // 买家换绑手机
                jumpStatus: false, // 跳过状态
                orderId: null
            }, // 买卖家信息收集表单
            paymentInfoModelTitle: '', // 买卖家支付信息收集模态窗显示状态
            paymentInfoModel: false, // 买卖家支付信息收集模态窗显示状态
            paymentInfoForm: {
                sellerCollectAccountType: '1',
                bankName: null, // 银行名称
                sellerCollectAccount: null, // 银行卡号 or 支付宝号
                realName: null, // 用户实名
                paymentAccount: null,
                idToken: null, // 校验是否提交过
                isOfflineRefundBuyer: false,
                orderId: null,
                cancelReason: {}, // 取消原因
                cancelReasonId: null, // 取消原因ID
                cardInfo: {}, // 卡片上的信息
                realNameOne: null, // 收款人姓名
                paymentAccountOne: null, // 收款账户
                paymentAccountTwo: null // 确认收款账户
            }, // 买卖家支付信息收集表单
            orderInfoModel: false, // 查看订单模态窗显示状态
            submitState: true, // 限制连点提交
            loadingBt: false, // loading
            sellerAuthentication: false, // 卖家实人认证弹窗状态
            goodsCardLabelType: false, // 商品常用咨询标签提交弹窗状态
            goodsCardLabelFrom: {
                goodsNo: '',
                labelId: 0,
                idToken: '',
                value: null,
                radioValue: null,
                checkboxValue: []
            }, // 表单提交数据
            orderListState: false, // 订单弹窗显示状态
            myProductList: false, // 我的商品弹窗显示状态
            myProductEstablish: false,
            labelAfterSaleList: false, // 选择您要售后的订单弹窗显示状态
            orderListData: [], // 订单列表
            orderListDatacopy: [], // 订单列表
            labelAfterSaleListData: [], // 选择您要售后的订单列表
            page: 1, // 订单分页
            isempty: false, // 发送卡片状态
            trendsForm: {}, // 动态表单数据
            trendsState: false, // 动态表单数据
            regularState: false,
            recyclingPayMsgData: null, // 回收弹窗数据
            recyclingPayMsgModel: false, // 回收弹窗
            evaluateModel: false, // 评价
            evaluateIconList: [
                { img: 'https://oss.pzds.com/pc-ssr-im/evaluate1.png', active: 'https://oss.pzds.com/pc-ssr-im/evaluate11.png', info: '非常不满意' },
                { img: 'https://oss.pzds.com/pc-ssr-im/evaluate2.png', active: 'https://oss.pzds.com/pc-ssr-im/evaluate22.png', info: '不满意' },
                { img: 'https://oss.pzds.com/pc-ssr-im/evaluate3.png', active: 'https://oss.pzds.com/pc-ssr-im/evaluate33.png', info: '一般' },
                { img: 'https://oss.pzds.com/pc-ssr-im/evaluate4.png', active: 'https://oss.pzds.com/pc-ssr-im/evaluate44.png', info: '满意' },
                { img: 'https://oss.pzds.com/pc-ssr-im/evaluate5.png', active: 'https://oss.pzds.com/pc-ssr-im/evaluate55.png', info: '非常满意' }
            ],
            evaluateIconLists: [
                { active: 'https://oss.pzds.com/mobileV3/pic-verydissatisfied@2x.png', img: 'https://oss.pzds.com/mobileV3/pic-verydissatisfied-un@2x.png', info: '非常不满意' },
                { active: 'https://oss.pzds.com/mobileV3/pic-dissatisfied@2x.png', img: 'https://oss.pzds.com/mobileV3/pic-dissatisfied-un@2x.png', info: '不满意' },
                { active: 'https://oss.pzds.com/mobileV3/pic-general@2x.png', img: 'https://oss.pzds.com/mobileV3/pic-general-un@2x.png', info: '一般' },
                { active: 'https://oss.pzds.com/mobileV3/pic-satisfied@2x.png', img: 'https://oss.pzds.com/mobileV3/pic-satisfied-un@2x.png', info: '满意' },
                { active: 'https://oss.pzds.com/mobileV3/pic-verysatisfied@2x.png', img: 'https://oss.pzds.com/mobileV3/pic-verysatisfied-un@2x.png', info: '非常满意' }
            ],
            evaluateIconIndex: null, // 满意度选中
            evaluateInput: '', // 提交评价信息
            evaluateTextList: [{ info: '已解决' }, { info: '未解决' }],
            evaluateTextIndex: null, // 解决问题选中
            evaluateState: false, //  是否选中
            evaluateSubmitState: false, // 是否提交
            evaluateSubmitNum: 3, // 提交倒计时

            /** @投诉工单 **/
            complaintId: '', // 投诉工单id
            complaintEvaluateModel: false, // 投诉工单评价
            complaintEvaluateIconIndex: null, // 满意度选中
            complaintEvaluateInput: '', // 提交评价信息
            complaintEvaluateTextList: [{ info: '已解决' }, { info: '未解决' }],
            complaintEvaluateTextIndex: null, // 解决问题选中
            complaintEvaluateState: false, //  是否选中
            complaintEvaluateSubmitState: false, // 是否提交
            complaintEvaluateSubmitNum: 3, // 提交倒计时

            afterSalesSubmitState: false, // 售后是否提交
            timer: null, // 提交倒计时
            sellerAuthenticationState: null, // 实名状态
            sellerAuthenticationModel: false, // 实名弹窗
            downloadModel: false, // 下载弹窗
            downloadInfo: '', // 下载提示
            receivingAccountModel: false, // 查看收款账户弹窗
            receivingAccountModelData: null, // 查看收款账户弹窗
            income: null,
            serviceCharge: null,

            isSyncPrice: null, // 是否同步砍价价格
            checkIcon: 'https://oss.pzds.com/imgv2/icon-radio_sel20.png',
            unCheckIcon: 'https://oss.pzds.com/imgv2/icon-radio_unsel20.png',
            recycleBargainingForm: {},
            buyerSellerLinkForm: {},
            dataGroup: {},
            expeditingLaunchData: {},
            countdownText: '',
            countdownTimer: null,
            showCountdown: false,
            isOutsideAllowedHours: false,
            provideInformationData: {},
            provideInformationModel: false,
            afterSalesOrdersData: {},
            questionList: {},
            afterSalesEvaluationData: {
                evaluationConfig: {
                    optionGroups: [], // 评价选项组
                    title: '请对本次客服的服务进行评价'
                }
            },
            selectedTags: [], // 添加选中的标签数组
            evaluateIconIndexs: -1, // 初始化为-1
            hoveredIconIndex: null, // 鼠标悬停的图标索引
            afterSalesEvaluationModel: false,
            completeReview: false,
            evaluateContent: '', // 评价内容
            workOrderNo: '', // 工单号
            sourceImUserId: '',
            answer: {},
            showAgreement: false,
            categoryList: [],
            selectedCategoryId: null,
            /* 新品类商品modal（套餐、库存、单价） */
            skuInvolveEdit: {
                show: false,
                data: null
            },
        }
    },
    computed: {
        ...mapGetters({
            userinfo: 'user/userinfo',
            customerInfo: 'ry/customerInfo',
            agreementInfo: 'ry/agreementInfo'
        }),
        // 新增计算属性来控制确认按钮的禁用状态
        confirmButtonDisabled () {
            return this.showCountdown || this.isOutsideAllowedHours
        }
    },
    watch: {
        'goodsCardLabelFrom.value': {
            handler: throttle(function (newValue, oldVal) {
                if (newValue != oldVal) {
                    if (this.goodsCardLabelFrom.labelType !== 'PRICE') {
                        return
                    }
                    const params = {
                        action: {
                            gameId: this.goodsCardLabelFrom.gameId,
                            goodsCatalogueId: this.goodsCardLabelFrom.goodsCatalogueId,
                            goodsPrice: Number(newValue),
                            goodsNo: this.goodsCardLabelFrom.goodsNo
                        }
                    }
                    const priceReg = /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/
                    if (!priceReg.test(Number(newValue))) {
                        return
                    }
                    this.$api.getBargainFee(params).then(res => {
                        if (!res.success) {
                            this.$message.error(res.info)
                            return
                        }
                        this.serviceCharge = res.data.serviceFee
                        this.income = parseFloat(Number(newValue) - res.data.serviceFee).toFixed(2)
                    })
                }
            }, 500), // 节流时间间隔200毫秒
            deep: true // 深度监听
        }
    },
    // 组件销毁时清除计时器
    beforeDestroy () {
        if (this.countdownTimer) {
            clearInterval(this.countdownTimer)
            this.countdownTimer = null
        }
    },
    methods: {
        // 获取商品品类
        async getCategoryList() {
            const res = await this.$api.getGeneralGoodsCateList()
            if (!res.success) {
                return this.$message.error(res.info)
            }
            this.categoryList = res.data
            if (this.categoryList && this.categoryList.length > 0) {
                this.selectedCategoryId = this.categoryList[0].catalogueId
            }
        },
        // 我的商品搜索
        onSearchOrder () {
            const p = {
                action: {
                    goodsStatus: 'ON_STAND',
                    goodsCatalogueId: this.selectedCategoryId
                },
                page: 1,
                pageSize: 10
                // todo 添加商品类型筛选
            }
            if (this.query) {
                p.action.keywords = [this.query]
            }
            this.$api.getGeneralGoodsList(p).then(res => {
                if (res.success) {
                    this.orderListData = res.data.records
                    this.page = 1
                    if(this.orderListData.length > 0){
                        this.$nextTick(() => {
                            this.$refs.scrollTopList.addEventListener('scroll', this.throttle(this.handleScroll.bind(this, this.$api.getGeneralGoodsList, p, 'orderListData'), 500), true)
                        })
                    }
                } else {
                    this.$message.error(res.info)
                }
            })
        },
        quickFilterClick (id, index) {
            this.selectedCategoryId = id
            this.onSearchOrder()

            // 智能滚动到居中位置
            this.$nextTick(() => {
                const container = this.$refs.quickFilterContainer
                const targetElement = this.$refs[`quickItem${index}`]

                if (!container || !targetElement || !targetElement[0]) {
                    return
                }

                const item = targetElement[0]
                const containerWidth = container.offsetWidth
                const itemLeft = item.offsetLeft
                const itemWidth = item.offsetWidth

                // 计算目标滚动位置（让元素居中）
                const targetScrollLeft = itemLeft - (containerWidth / 2) + (itemWidth / 2)

                // 获取滚动边界
                const maxScrollLeft = container.scrollWidth - containerWidth

                // 智能调整：
                // 1. 如果居中后会超出右边界，则滚动到最右边
                // 2. 如果居中后会小于0，则滚动到最左边
                // 3. 否则滚动到居中位置
                let finalScrollLeft = targetScrollLeft

                if (targetScrollLeft < 0) {
                    finalScrollLeft = 0
                } else if (targetScrollLeft > maxScrollLeft) {
                    finalScrollLeft = maxScrollLeft
                }

                // 平滑滚动
                container.scrollTo({
                    left: finalScrollLeft,
                    behavior: 'smooth'
                })
            })
        },
        provideInformations (item) {
            this.provideInformationData = item
            this.provideInformationModel = true
        },
        provideInformationSubmit (formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    const _data = {
                        groupId: this.provideInformationData.groupId,
                        id: this.provideInformationData.cardId,
                        idToken: this.provideInformationData.buttonVO.idToken,
                        submitList: this.provideInformationData.buttonVO.submitList.map((item) => {
                            const submitItem = {
                                dataType: item.dataType,
                                name: item.name,
                                options: [],
                                value: ''
                            }

                            if (item.dataType === 'SINGLE') {
                                submitItem.value = item.value
                                submitItem.options = item.options || []
                            }
                            else if (item.dataType === 'CHECKBOX') {
                                submitItem.value = Array.isArray(item.value) ? item.value.join(',') : item.value
                                submitItem.options = item.options || []
                            }
                            else if (item.dataType === 'PICTURE') {
                                submitItem.value = Array.isArray(item.value) ? item.value.join(',') : item.value
                            }
                            else {
                                submitItem.value = item.value
                            }

                            return submitItem
                        })
                    }

                    this.loadingBt = true
                    this.$api.formataSubmit(_data).then(res => {
                        if (res.success) {
                            this.provideInformationModel = false
                            this.$message.success(res.info)
                            this.loadingBt = false
                        } else {
                            this.$message.error(res.info)
                            this.loadingBt = false
                        }
                    })
                } else {
                    console.warn('error submit!!')
                    return false
                }
            })
        },
        // 售后评价
        afterSalesEvaluation (par) {
            this.workOrderNo = par.workOrderNo
            this.callback = par.callback // 保存回调函数
            this.$api.afterSalesEvaluationAPI(par).then(res => {
                if (!res.success) {
                    this.$message.error(res.info)
                    return
                }
                this.afterSalesSubmitState = false // 重置提交状态
                // 确保数据结构完整
                this.afterSalesEvaluationData = {
                    answer: res.data.answer,
                    evaluationConfig: {
                        optionGroups: res.data?.evaluationConfig?.optionGroups || [],
                        title: res.data?.evaluationConfig?.title || '请对本次客服的服务进行评价'
                    }
                }
                if (res.data.answer) {
                    this.answer = res.data.answer
                    switch (this.answer.optionGroupId) {
                    case 1:
                        this.answer.img = 'https://oss.pzds.com/mobileV3/pic-verydissatisfied@2x.png'
                        this.answer.name = '非常不满意'
                        break
                    case 2:
                        this.answer.img = 'https://oss.pzds.com/mobileV3/pic-dissatisfied@2x.png'
                        this.answer.name = '不满意'
                        break
                    case 3:
                        this.answer.img = 'https://oss.pzds.com/mobileV3/pic-general@2x.png'
                        this.answer.name = '一般'
                        break
                    case 4:
                        this.answer.img = 'https://oss.pzds.com/mobileV3/pic-satisfied@2x.png'
                        this.answer.name = '满意'
                        break
                    case 5:
                        this.answer.img = 'https://oss.pzds.com/mobileV3/pic-verysatisfied@2x.png'
                        this.answer.name = '非常满意'
                        break
                    default:
                        break
                    }
                    this.completeReview = true
                } else {
                    this.evaluateIconIndexs = -1 // 重置选中状态
                    this.evaluateContent = '' // 重置评价内容
                    this.selectedTags = [] // 重置已选标签
                    this.afterSalesEvaluationModel = true
                }
            }).catch(() => {
                this.$message.error('获取评价配置失败')
            })
        },
        // 输入时校验，只允许输入数字
        validateInput (value) {
            // 如果输入的不是数字，则清空或还原为之前的值
            if (!/^\d*$/.test(value)) {
                this.buyerSellerLinkForm.latestPrice = value.replace(/[^\d]/g, '')
            }
        },
        buyerSellerLinkSend (val) {
            const par = {
                goodsNo: this.buyerSellerLinkForm.goodsNo,
                buyerId: Number(this.userinfo.id) === this.buyerSellerLinkForm.sellerId ? this.buyerSellerLinkForm.buyerId : this.buyerSellerLinkForm.sellerId,
                latestPrice: val.price
            }
            this.$api.consultSellerChangePriceAPI(par).then(res => {
                if (!res.success) {
                    this.$message.error(res.info)
                    return
                }
                this.$message.success('操作成功')
                this.buyerSellerLinkMsg = false
            })
        },
        recycleSend () {
            const par = {
                goodsNo: this.recycleBargainingForm.goodsNo,
                id: this.recycleBargainingForm.recycleId,
                latestPrice: this.recycleBargainingForm.latestPrice
            }
            this.loadingBt = true
            this.$api.recyclePriceChange(par).then(res => {
                this.loadingBt = false
                if (!res.success) {
                    this.$message.error(res.info)
                    return
                }
                this.$message.success(res.info)
                this.recycleBargainingModel = false
            })
        },
        confirm () {
            const par = {
                groupId: this.expeditingLaunchData.groupId
            }
            this.loadingBt = true
            this.$api.remindOnlineAPI(par).then(res => {
                this.loadingBt = false
                if (!res.success) {
                    this.$message.error(res.info)
                    return
                }
                this.$message.success('短信发送成功')
                this.expeditingLaunch = false
            })
        },
        // 回收商品卡片弹窗
        recycleBargaining (item) {
            this.recycleBargainingForm = item
            this.recycleBargainingModel = true
        },
        // 买卖家建联卡片修改价格
        sendlinkPriceCard (item, type) {
            this.buyerSellerLinkForm = item
            this.buyerSellerLinkForm.type = type
            this.buyerSellerLinkMsg = true
        },
        async sendlinkPriceCatalogueCard (item, type) {
            let orderDetailData = {
                spuData: null,
                skuList: [],
                itemData: item,
            };
           const res = await this.$api.getGeneralGoodsDetail({
                action: {
                    goodsNo: item.goodsNo
                }
            })
            if (res.success) {
                orderDetailData.spuData = res.data;
            }
            const res2 = await this.$api.getGeneralGoodsSkuDetail({
                goodsNo: item.goodsNo
            })
            if (res2.success) {
                // 将 master 为 true 的排在第一位
                orderDetailData.skuList = res2.data.sort((a, b) => {
                    if (a.master && !b.master) return -1;
                    if (!a.master && b.master) return 1;
                    return 0;
                });
            }
            this.skuInvolveEdit.show = true
            this.skuInvolveEdit.data = orderDetailData
        },

        /**
         * 选择是否同步砍价
         */
        checkSyncHandler (checking) {
            this.isSyncPrice = checking
        },
        // 账号信息来源
        infoSourceClick (_, val) {
            this.$api.getAccountSourceList().then(dataRes => {
                this.accountSourceList = dataRes.data

                this.accountSourceForm = {
                    sellerGameAccount: '',
                    accountSource: 'ORIGINAL_USER', // 来源
                    orderId: val.content.content.orderId
                }
                this.accountSourceModel = true
                const _data = {
                    action: {
                        orderId: this.accountSourceForm.orderId
                    }
                }
                this.$api.accountSourceDetail(_data).then(res => {
                    if (res.data) {
                        this.accountSourceForm.sellerGameAccount = res.data.sellerGameAccount ? res.data.sellerGameAccount : null
                        this.accountSourceForm.accountSource = res.data.accountSource ? res.data.accountSource : 'ORIGINAL_USER'
                    }
                })
            })
        },
        // 账号来源提交
        accountSourceSubmit (formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    const _data = {
                        action: {
                            orderId: this.accountSourceForm.orderId,
                            sellerGameAccount: this.accountSourceForm.sellerGameAccount,
                            accountSource: this.accountSourceForm.accountSource
                        }
                    }
                    this.loadingBt = true
                    this.$api.accountSourceCommit(_data).then(res => {
                        if (res.success) {
                            this.accountSourceModel = false
                            this.$message.success(res.info)
                            this.loadingBt = false
                        } else {
                            this.$message.error(res.info)
                            this.loadingBt = false
                        }
                    })
                } else {
                    console.warn('error submit!!')
                    return false
                }
            })
        },
        // 买卖家信息收集确认表
        sellerInfoClick (title, val) {
            this.sellerInfoModelTitle = title
            if (title == '卖家信息收集确认表') {
                this.sellerInfoForm = {
                    sellerCollectAccountType: null, // 支付类型
                    sellerPhone: null, // 联系人收集
                    sellerQq: null, // 联系人QQ
                    sellerWx: null, // 联系人微信
                    sellerRealName: null, // 实名
                    bankName: null, // 银行名称
                    sellerCollectAccount: null, // 银行卡号 or 支付宝号
                    idToken: val.content.content.idToken, // 校验是否提交过
                    jumpStatus: false,
                    orderId: val.content.content.orderId
                }
                // 校验token是否提交
                const _idData = {
                    idToken: this.sellerInfoForm.idToken
                }
                this.$api.commonsPublicIdToken(_idData).then(res => {
                    if (res.success) {
                        this.sellerInfoForm.sellerCollectAccountType = '1'
                        this.$api.groupGetPaymentInformation().then(res => {
                            if (res.data) {
                                this.sellerInfoForm.sellerCollectAccountType = res.data.collectAccountType ? res.data.collectAccountType.toString() : '1'
                                this.sellerInfoForm.sellerPhone = res.data.linkPhone ? res.data.linkPhone : null
                                this.sellerInfoForm.sellerQq = res.data.linkQq ? res.data.linkQq : null
                                this.sellerInfoForm.sellerWx = res.data.linkWx ? res.data.linkWx : null
                                this.sellerInfoForm.bankName = res.data.bankName ? res.data.bankName : null
                                this.sellerInfoForm.sellerCollectAccount = res.data.collectAccount ? res.data.collectAccount : null
                                this.sellerInfoForm.sellerRealName = res.data.realName ? res.data.realName : null
                            }
                        })
                        this.sellerInfoModel = true
                    } else {
                        this.$message.error('您已填写，请勿重复提交')
                    }
                })
            } else if (title == '买家信息收集确认表') {
                this.buyerInfoForm = {
                    buyerPhone: null, // 联系人收集
                    buyerQq: null, // 联系人QQ
                    buyerWx: null, // 联系人微信
                    gameAccountBindPhone: null, // 买家换绑手机
                    jumpStatus: false,
                    orderId: val.content.content.orderId
                }
                this.$api.groupGetPaymentInformation().then(res => {
                    if (res.data) {
                        this.buyerInfoForm.buyerPhone = res.data.linkPhone ? res.data.linkPhone : null
                        this.buyerInfoForm.buyerQq = res.data.linkQq ? res.data.linkQq : null
                        this.buyerInfoForm.buyerWx = res.data.linkWx ? res.data.linkWx : null
                    }
                })
                this.sellerInfoModel = true
            }
        },
        // 买卖家信息收集确认表提交
        sellerInfoSubmit (formName, title) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    if (title == '卖家信息收集确认表') {
                        // 卖家提交
                        const _data = {
                            action: {
                                userId: this.userinfo.id,
                                ...this.sellerInfoForm
                            }
                        }
                        this.loadingBt = true
                        this.$api.groupPaymentInformation(_data).then(res => {
                            if (res.success) {
                                this.sellerInfoModel = false
                                this.$message.success(res.info)
                                this.loadingBt = false
                            } else {
                                this.$message.error(res.info)
                                this.loadingBt = false
                            }
                        })
                    } else {
                        // 买家提交
                        const _data = {
                            action: {
                                userId: this.userinfo.id,
                                ...this.buyerInfoForm
                            }
                        }
                        this.loadingBt = true
                        this.$api.groupOrderBuyerInfoCollect(_data).then(res => {
                            if (res.success) {
                                this.sellerInfoModel = false
                                this.$message.success(res.info)
                                this.loadingBt = false
                            } else {
                                this.$message.error(res.info)
                                this.loadingBt = false
                            }
                        })
                    }
                } else {
                    console.warn('error submit!!')
                    return false
                }
            })
        },
        // 切换时清空账号信息
        sellerCollectAccount () {
            if (this.sellerInfoModelTitle == '卖家信息收集确认表') {
                this.sellerInfoForm.sellerCollectAccount = null
            } else {
                this.buyerInfoForm.sellerCollectAccount = null
            }
        },
        // 买卖付款信息收集
        paymentInfoClick (title, val) {
            this.paymentInfoForm = {
                sellerCollectAccountType: '1',
                bankName: null, // 银行名称
                sellerCollectAccount: null, // 银行卡号 or 支付宝号
                realName: null, // 用户实名
                idToken: val.content.content.idToken, // 校验是否提交过
                isOfflineRefundBuyer: val.content.content.isOfflineRefundBuyer,
                orderId: val.content.content.orderId
            }
            this.paymentInfoModelTitle = title
            // 校验token是否提交
            const _idData = {
                idToken: this.paymentInfoForm.idToken
            }
            this.$api.commonsPublicIdToken(_idData).then(res => {
                if (res.success) {
                    this.$api.groupGetPaymentInformation().then(res => {
                        this.paymentInfoModel = true
                        if (res.data) {
                            this.paymentInfoForm.realName = res.data.realName ? res.data.realName : null
                            this.paymentInfoForm.sellerCollectAccountType = res.data.collectAccountType ? String(res.data.collectAccountType) : '1'
                            this.paymentInfoForm.sellerCollectAccount = res.data.collectAccount ? res.data.collectAccount : null
                            this.paymentInfoForm.bankName = res.data.bankName ? res.data.bankName : null
                        }
                    })
                } else {
                    this.$message.error('您已填写，请勿重复提交')
                }
            })
        },
        // 买卖家付款信息提交
        paymentInfoSubmit (formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    const _data = {
                        action: {
                            userId: this.userinfo.id,
                            ...this.paymentInfoForm
                        }
                    }
                    this.loadingBt = true
                    this.$api.groupCancelPaymentInformation(_data).then(res => {
                        if (res.success) {
                            this.paymentInfoModel = false
                            this.$message.success(res.info)
                            this.loadingBt = false
                        } else {
                            this.$message.error(res.info)
                            this.loadingBt = false
                        }
                    })
                } else {
                    console.warn('error submit!!')
                    return false
                }
            })
        },
        // 获取查看订单信息
        getOrderInfo (_, val) {
            const data = {
                orderNo: val.content.content.orderNo
            }
            this.$api.orderDetails(data).then(res => {
                this.agencyOrderInfo = res.data
                this.orderInfoModel = true
            })
        },
        // 查看订单确认无误
        orderInfoSubmit (val) {
            if (!this.submitState) {
                return
            }
            this.submitState = false
            const data = {
                action: {
                    orderId: val.orderId
                }
            }
            this.$api.confirmAgencyOrderInfo(data).then(res => {
                if (res.success) {
                    this.orderInfoModel = false
                    this.submitState = true
                    // 请求接口自动发送消息
                    this.$parent.sendMsgOrderInfo()
                } else {
                    this.submitState = true
                }
            })
        },
        // 查看订单有疑问
        orderInfoSubmitError () {
            this.orderInfoModel = false
            // 请求接口自动发送消息
            this.$parent.sendMsgOrderInfoError()
        },
        // 关闭弹窗
        closeModel () {
            this.recycleBargainingModel = false
            this.complaintEvaluateModel = false
            this.expeditingLaunch = false
            this.provideInformationModel = false
            this.afterSalesOrdersDialog = false
            this.afterSalesEvaluationModel = false
            this.completeReview = false
            this.buyerSellerLinkMsg = false
            this.accountSourceModel = false
            this.sellerInfoModel = false
            this.paymentInfoModel = false
            this.orderInfoModel = false
            this.sellerAuthentication = false
            this.goodsCardLabelType = false
            this.orderListState = false
            this.myProductList = false
            this.myProductEstablish = false
            this.labelAfterSaleList = false
            this.trendsState = false
            this.regularState = false
            this.recyclingPayMsgModel = false
            this.evaluateModel = false
            this.sellerAuthenticationModel = false
            this.downloadModel = false
            this.receivingAccountModel = false
            if (this.countdownTimer) {
                clearInterval(this.countdownTimer)
                this.countdownTimer = null
            }
            this.skuInvolveEdit.show = false
            this.skuInvolveEdit.data = null
            this.$store.commit('ry/SET_GLOBAL_SHOW_COMMODITY', false)
        },
        // 打开卖家实人认证弹窗
        openSellyModel () {
            this.sellerAuthentication = true
        },
        // 卖家实人认证跳转
        gotoAuthentication () {
            this.sellerAuthentication = false
            if (!this.userinfo.isFaceCertified) {
                this.$router.push({
                    path: '/account/realPerson'
                })
            } else {
                this.$message.success('已实名')
            }
        },
        // 打开常用信息标签提交
        getGoodsCardLabelSubmit (_, val, resdata) {
            // 校验token是否提交
            const _idData = {
                idToken: val.content.content.idToken
            }
            this.$api.commonsPublicIdToken(_idData).then(res => {
                if (res.success) {
                    this.$api.goodsGoodsDetails({ action: { goodsNo: val.content.content.goodsNo } }).then(r => {
                        const { gameId, goodsCatalogueId } = r.data
                        if (res.success) {
                            this.goodsCardLabelFrom = {
                                ...val.content.content,
                                ...resdata,
                                gameId,
                                goodsCatalogueId,
                                value: val.content.content.value ? val.content.content.value : null,
                                radioValue: null,
                                checkboxValue: []
                            }
                        } else {
                            this.$message.error(res.info)
                        }
                    })
                    this.goodsCardLabelType = true
                } else {
                    this.$message.error('您已填写，请勿重复提交')
                }
            })
        },
        // 提交常用信息标签信息
        goodsCardLabelSubmit (formName) {
            if (this.goodsCardLabelFrom.labelType === 'PRICE') {
                if (!this.goodsCardLabelFrom.value || this.goodsCardLabelFrom.value <= this.serviceCharge) {
                    return this.$message.error(`低于最低可售卖价格${this.serviceCharge}元，请重新设置账号价格`)
                } else if (this.isSyncPrice === null) {
                    return this.$message.error('请完成选项')
                }
            }

            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.loadingBt = true
                    const data = {
                        action: {
                            goodsNo: this.goodsCardLabelFrom.goodsNo,
                            labelId: this.goodsCardLabelFrom.labelId,
                            idToken: this.goodsCardLabelFrom.idToken,
                            csId: this.customerInfo.targetId
                        }
                    }
                    if (this.goodsCardLabelFrom.fieldType == 'SECTION' || this.goodsCardLabelFrom.fieldType == 'TEXT') {
                        data.action.value = this.goodsCardLabelFrom.value
                        if (this.goodsCardLabelFrom.labelType === 'PRICE') {
                            data.action.updatePrice = this.isSyncPrice
                        }
                    } else {
                        data.action.value = JSON.stringify(this.goodsCardLabelFrom.value)
                    }

                    this.$api.getGoodsCardLabelSubmit(data).then(res => {
                        if (res.success) {
                            this.goodsCardLabelType = false
                            this.loadingBt = false
                            this.isSyncPrice = null
                            this.goodsCardLabelFrom = {
                                goodsNo: '',
                                labelId: 0,
                                idToken: '',
                                value: null,
                                radioValue: null,
                                checkboxValue: []
                            }
                            this.$message.success(res.info)
                        } else {
                            this.$message.error(res.info)
                            this.loadingBt = false
                        }
                    })
                } else {
                    console.warn('error submit!!')
                    return false
                }
            })
        },
        // 多选
        getCheckbox (val) {
            const data = []
            this.goodsCardLabelFrom.selectList.map(item => {
                val.map((v) => {
                    if (v == item.id) {
                        data.push(item)
                    }
                })
            })
            this.goodsCardLabelFrom.value = data
        },
        // 单选
        getRadio (val) {
            const data = []
            this.goodsCardLabelFrom.selectList.map(item => {
                if (val == item.id) {
                    data.push(item)
                }
            })
            this.goodsCardLabelFrom.value = data
        },
        // 催上线
        getExpeditingLaunch (item) {
            this.$trackEvent({ eventType: 'click', trackParams: {
                eventName: 'CC建联-发送催上线',
                groupId: item.groupId
            }})
            const p = {
                groupId: item.groupId
            }
            this.$api.remindOnlineQueryAPI(p).then(res => {
                if (!res.success) {
                    this.$message.error(res.info)
                }
                this.expeditingLaunchData = {
                    ...res.data,
                    groupId: item.groupId
                }
                this.expeditingLaunch = true

                // 检查时间限制
                this.checkTimeRestriction(item.timestamp)

                // 检查上次发送时间，计算倒计时
                this.checkLastSendTime(res.data.lastSendTime, item.timestamp)
            })
        },
        // 检查时间限制（10:00 - 22:00）
        checkTimeRestriction (currentDate) {
            dayjs.extend(utc)
            dayjs.extend(timezone)
            const hour = dayjs(currentDate).tz('Asia/Shanghai').hour()
            this.isOutsideAllowedHours = (hour < 10 || hour >= 22)
        },

        // 检查上次发送时间，计算倒计时
        checkLastSendTime (lastSendTime, timestamp) {
            if (!lastSendTime) { return }

            // 清除可能存在的倒计时
            if (this.countdownTimer) {
                clearInterval(this.countdownTimer)
                this.countdownTimer = null
            }
            // 使用dayjs处理时区问题
            const lastSendTimeDate = dayjs(lastSendTime).tz('Asia/Shanghai')
            // 半小时后的时间
            const halfHourLater = lastSendTimeDate.add(30, 'minutes')
            // 当前服务器时间
            const currentServerTime = dayjs(timestamp).tz('Asia/Shanghai')
            // 计算时间差（毫秒）
            let remainingTime = halfHourLater.diff(currentServerTime)

            if (remainingTime > 0) {
                this.showCountdown = true
                this.updateCountdown(remainingTime)

                // 启动倒计时
                this.countdownTimer = setInterval(() => {
                    remainingTime -= 1000

                    if (remainingTime <= 0) {
                        clearInterval(this.countdownTimer)
                        this.showCountdown = false
                    } else {
                        this.updateCountdown(remainingTime)
                    }
                }, 1000)
            }
        },

        // 更新倒计时文本
        updateCountdown (remainingTime) {
            const hours = Math.floor(remainingTime / (1000 * 60 * 60)).toString().padStart(2, '0')
            const minutes = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60)).toString().padStart(2, '0')
            const seconds = Math.floor((remainingTime % (1000 * 60)) / 1000).toString().padStart(2, '0')
            this.countdownText = `${hours}:${minutes}:${seconds}`
        },
        // 获取订单列表数据
        getOrderListData () {
            const data = {
                action: { orderStatus: 'COMPLETE' },
                page: 1,
                pageSize: 20
            }
            const config = {
                dataField: 'orderListState'
            }
            this.fetchData(this.$api.orderListNew, data, 'orderListData', this.handleScroll, config)
        },
        async getMyProductEstablish (item) {
            // 先获取品类
            await this.getCategoryList()
            const p = {
                action: {
                    goodsStatus: 'ON_STAND',
                    // goodsNo: this.query
                    goodsCatalogueId: this.selectedCategoryId
                },
                page: 1,
                pageSize: 10
            }
            this.dataGroup = item
            this.$api.getGeneralGoodsList(p).then(res => {
                if (res.success) {
                    this.orderListData = res.data.records
                    this.orderListDatacopy = res.data.records
                    this.myProductEstablish = true
                    this.isempty = false
                    this.page = 1
                    this.$nextTick(() => {
                        this.$refs.scrollTopList.addEventListener('scroll', this.throttle(this.handleScroll.bind(this, this.$api.getGeneralGoodsList, p, 'orderListData'), 500), true)
                    })
                } else {
                    this.$message.error(res.info)
                }
            })
        },
        // 获取我的商品上架中的数据
        getMyProduct (item) {
            const p = {
                action: { status: 'ON_STAND' },
                page: 1,
                pageSize: 10
            }
            const config = {
                dataField: 'myProductList'
            }
            this.dataGroup = item
            this.fetchData(this.$api.sellerCenter, p, 'orderListData', this.handleScroll, config)
        },

        getLabelAfterSale () {
            const data = {
                action: {
                    orderStatus: 'COMPLETE'
                },
                page: 1,
                pageSize: 10
            }
            const config = {
                dataField: 'labelAfterSaleList'
            }
            this.fetchData(this.$api.orderList, data, 'labelAfterSaleListData', this.handleScroll, config)
        },
        // 通用的数据获取方法
        fetchData (apiMethod, requestData, dataField, scrollHandler, config) {
            apiMethod(requestData).then(res => {
                if (res.success) {
                    this[dataField] = res.data.records
                    this[config.dataField] = true
                    this.isempty = false
                    this.page = 1
                    this.$nextTick(() => {
                        this.$refs.scrollTopList.addEventListener('scroll', this.throttle(scrollHandler.bind(this, apiMethod, requestData, dataField), 500), true)
                    })
                } else {
                    this.$message.error(res.info)
                }
            })
        },
        handleScroll (apiMethod, requestData, dataField) {
            const scrollTop = this.$refs.scrollTopList.scrollTop
            const clientHeight = this.$refs.scrollTopList.clientHeight
            const scrollHeight = this.$refs.scrollTopList.scrollHeight
            const height = 79
            if (scrollTop + clientHeight >= scrollHeight - height && !this.isempty) {
                this.isempty = true
                this.page += 1
                const data = {
                    ...requestData,
                    page: this.page
                }

                apiMethod(data).then(res => {
                    if (res.success) {
                        this[dataField] = this[dataField].concat(res.data.records)
                        this.isempty = false
                        if (res.data.records.length <= 0) {
                            this.isempty = true
                        }
                    } else {
                        this.$message.error(res.info)
                    }
                })
            } else {
                return false
            }
        },
        // handleScroll(api ,type) {
        //     let scrollTop = this.$refs.scrollTopList.scrollTop, //变量scrollTop是滚动条滚动时，距离顶部的距
        //         clientHeight = this.$refs.scrollTopList.clientHeight, //变量windowHeight是可视区的高度
        //         scrollHeight = this.$refs.scrollTopList.scrollHeight, //变量scrollHeight是滚动条的总高度
        //         height = 79 //根据项目实际定义
        //     if (scrollTop + clientHeight >= scrollHeight - height && !this.isempty) {
        //         this.isempty = true
        //         this.page = parseInt(this.page) + parseInt(1) //页数+1
        //         let data = {
        //             action: {
        //                 orderStatus: 'COMPLETE'
        //             },
        //             page: this.page,
        //             pageSize: 20
        //         }
        //         if(type == 1){
        //             data.action.orderStatus = 'COMPLETE';
        //         }else{
        //             data.action.status = 'ON_STAND';
        //         }
        //         api(data).then((res) => {
        //             if (res.success) {
        //                 this.orderListData = this.orderListData.concat(res.data.records)
        //                 this.isempty = false
        //                 if (res.data.records.length <= 0) {
        //                     this.isempty = true
        //                 }
        //             } else {
        //                 this.$message.error(res.info)
        //             }
        //         })
        //     } else {
        //         return false
        //     }
        // },
        throttle (func, wait) {
            let lastTime = null
            let timeout
            return () => {
                const context = this
                const now = new Date()
                const arg = arguments
                if (now - lastTime - wait > 0) {
                    if (timeout) {
                        clearTimeout(timeout)
                        timeout = null
                    }
                    func.apply(context, arg)
                    lastTime = now
                } else if (!timeout) {
                    timeout = setTimeout(() => {
                        func.apply(context, arg)
                    }, wait)
                }
            }
        },
        sendGoodsCards (item) {
            console.log(item, 'item')
            this.$trackEvent({ eventType: 'click', trackParams: {
                eventName: 'CC建联-发送商品',
                goodsNo: item.goodsNo,
            }})
            const par = {
                goodsNo: item.goodsNo,
                groupId: this.dataGroup.groupId,
                catalogueId: item.goodsCatalogueId
            }
            this.$api.orderSendGoodsAPI(par).then(res => {
                if (!res.success) {
                    this.$message.error(res.info)
                }
                this.myProductEstablish = false
            })
        },
        // 发送订单卡片
        sendGoodsCard (item, type) {
            if (this.dataGroup.type === 2) {
                const par = {
                    goodsNo: item.goodsNo,
                    groupId: this.dataGroup.groupId
                }
                this.$api.recycleSendRecycleBargainingMsgAPI(par).then(res => {
                    if (!res.success) {
                        this.$message.error(res.info)
                    }
                    this.myProductList = false
                })
            } else {
                this.$store.commit('ry/SET_CONSULT', item)
                this.$store.dispatch('ry/sendCustom0rderCardMsg', `${type == 1 ? 'panzhi:consultOrderMsg' : 'panzhi:recycleGoodsGuideMsg'}`)
            }
        },
        // 售后
        onQuestionList (val) {
            const data = {
                orderNo: this.afterSalesOrdersData.orderNo,
                questionTypeId: val.questionTypeId,
                sourceImUserId: this.sourceImUserId
            }
            this.$api.afterSalesV2ApplyAPI(data).then(res => {
                if (!res.success) { return this.$message.error(res.info) }
                this.$store.commit('ry/SET_CONVERSATION_ACTIVE', 0)
                const data = {
                    targetId: res.data.buyerAfterSalesGroupId,
                    conversationType: 3
                }
                this.$store.dispatch('ry/join', data)
                this.$store.commit('ry/SET_ORDER_FLOW_SHOW', false)
                this.$store.commit('ry/SET_ORDER_FLOW', [])
                this.afterSalesOrdersDialog = false
            })
        },

        async toPage (item, id) {
            try {
                const { data: orderDetails } = await this.$api.orderDetails({ orderNo: item.orderNo })
                this.afterSalesOrdersData = orderDetails
                this.sourceImUserId = id
                const { data: questionData } = await this.$api.afterSalesQuestionListAPI({goodsCatalogueId: item.goodsCatalogueId})
                this.questionList = questionData
                this.orderListState = false
                this.labelAfterSaleList = false
                this.afterSalesOrdersDialog = true
            } catch (error) {
                this.$message.error(error.info || '获取售后信息失败')
            }
        },
        // 获取动态表单数据
        getFormComp (fromData) {
            let formDataActionList = []
            if (fromData.type === 'SELLER_SUPPLEMENT_COMPENSATION_AGENCY' || fromData.type === 'SELLER_COLLECTION_ACCOUNT_NUMBER_AGENCY') {
                formDataActionList = fromData.formDataActionList.map(item => {
                    if (item.value) {
                        item.disabled = true
                    }
                    // 为CHECKBOX类型设置默认空数组
                    if (item.dataType === 'CHECKBOX' && !item.value) {
                        item.value = []
                    }
                    return {
                        ...item
                    }
                })
                this.trendsForm = { ...fromData, formDataActionList }
            } else {
                // 为所有CHECKBOX类型字段设置默认空数组
                if (fromData.formDataActionList) {
                    fromData.formDataActionList.forEach(item => {
                        if (item.dataType === 'CHECKBOX' && !item.value) {
                            item.value = []
                        }
                    })
                }
                this.trendsForm = { ...fromData }
            }
            this.trendsState = true
            // 在下一个tick清除表单验证状态，避免初始化时显示验证错误
            this.$nextTick(() => {
                if (this.$refs.trendsForm) {
                    this.$refs.trendsForm.clearValidate()
                }
            })
        },
        // 提交动态表单数据
        trendsFormSubmit (formName) {
            this.$refs[formName].validate(async valid => {
                if (valid) {
                    this.loadingBt = true
                    const trendsForm = JSON.parse(JSON.stringify(this.trendsForm))
                    trendsForm.formDataActionList.map(item => {
                        if (item.dataType == 'SINGLE') {
                            item.options.map(i => {
                                if (item.value == i.name) {
                                    item.value = i.value
                                }
                            })
                        }
                        if (item.fieldType == 'PASSWORD') {
                            item.value = encrypt(item.value)
                        }
                        if (item.fieldType == 'ACCOUNT') {
                            if (trendsForm.type != 'BUYER_CONFIRM_ORDER_COMPLETE_AGENCY') {
                                item.value = encrypt(item.value)
                            }
                        }
                        if (item.dataType == 'PICTURE') {
                            item.value = item.value?.join()
                        }
                        if (item.dataType == 'CHECKBOX') {
                            item.value = item.value.join()
                        }
                    })

                    let data
                    switch (trendsForm.type) {
                    case 'SELLER_SUPPLEMENT_COMPENSATION':
                        data = { ...trendsForm }
                        this.$api.submitSupplementCompensationApi(data).then(res => {
                            if (res.success) {
                                this.loadingBt = false
                                this.trendsState = false
                                this.$message.success('操作成功')
                            } else {
                                this.$message.error(res.info)
                                this.loadingBt = false
                            }
                        })
                        break
                    case 'SELLER_SUPPLEMENT_COMPENSATION_AGENCY':
                        data = {
                            orderId: trendsForm.orderId,
                            formField: trendsForm?.formDataActionList || []
                        }
                        this.$api.agencyOrderCreateContract(data).then(res => {
                            if (res.success) {
                                this.loadingBt = false
                                this.trendsState = false
                                this.$message.success('操作成功')
                            } else {
                                this.$message.error(res.info)
                                this.loadingBt = false
                            }
                        })
                        break
                    case 'BUYER_CONFIRM_ORDER_COMPLETE_AGENCY':
                        if (
                            trendsForm?.formDataActionList.find(el => el.fieldType === 'DEFAULT') &&
                            trendsForm?.formDataActionList.find(el => el.fieldType === 'DEFAULT').value != trendsForm.text
                        ) {
                            this.$message.error('输入文本有误，请重新输入！')
                            this.loadingBt = false
                            return
                        }
                        data = {
                            orderId: trendsForm.orderId,
                            formField: trendsForm?.formDataActionList || []
                        }
                        this.$api.agencyOrderBuyerConfirm(data).then(res => {
                            if (res.success) {
                                this.loadingBt = false
                                this.trendsState = false
                                this.$message.success('操作成功')
                            } else {
                                this.$message.error(res.info)
                                this.loadingBt = false
                            }
                        })
                        break
                    // 卖家提供收款账户（中介）表单提交
                    case 'SELLER_COLLECTION_ACCOUNT_NUMBER_AGENCY':
                        data = {
                            orderId: trendsForm.orderId,
                            formField: trendsForm?.formDataActionList || []
                        }
                        try {
                            const res = await this.$api.sellerFillPaymentInformation(data)
                            if (res.success) {
                                this.loadingBt = false
                                this.trendsState = false
                                this.$message.success('操作成功')
                            }
                        } catch (error) {
                            this.$message.error(error.message)
                            this.loadingBt = false
                        }
                        break

                    default:
                        data = { ...trendsForm }
                        this.$api.workorderCardButtonSubmit(data).then(res => {
                            if (res.success) {
                                this.loadingBt = false
                                this.trendsState = false
                                this.$message.success('操作成功')
                            } else {
                                this.$message.error(res.info)
                                this.loadingBt = false
                            }
                        }).finally(() => {
                            this.loadingBt = false
                        })
                        break
                    }
                } else {
                    console.warn('error submit!!')
                    return false
                }
            })
        },
        // 固定表单
        regularFrom (fromData, item) {
            switch (fromData.isBuy) {
            case 3:
                // 卖家禁止修改实名信息
                this.$api.workorderGetPaymentAccount().then(res => {
                    this.paymentInfoForm = {
                        paymentType: String(res.data.paymentType) || '1',
                        paymentAccount: res.data.paymentAccount, // 银行卡号 or 支付宝号
                        confirmPaymentAccount: '', // 银行卡号 or 支付宝号
                        realName: res.data.realName, // 用户实名
                        cardInfo: item,
                        ...fromData
                    }
                    this.regularState = true
                })
                break
            case 2:
                // 卖家禁止修改实名信息
                const data = {
                    orderId: fromData.orderId
                }
                this.$api.sellerPaymentAccount(data).then(res => {
                    if (res.success) {
                        if (res.data.status == 1) {
                            this.paymentInfoForm = {
                                paymentType: String(res.data.paymentType) || '1',
                                paymentAccount: res.data.paymentAccount, // 银行卡号 or 支付宝号
                                confirmPaymentAccount: '', // 银行卡号 or 支付宝号
                                realName: res.data.realName, // 用户实名
                                cardInfo: item,
                                ...fromData
                            }
                            this.regularState = true
                        } else if (res.data.status == 2) {
                            this.sellerAuthenticationState = 2
                            this.sellerAuthenticationModel = true
                        } else if (res.data.status == 3) {
                            this.sellerAuthenticationState = 3
                            this.sellerAuthenticationModel = true
                        }
                    } else {
                        this.$message.error(res.info)
                    }
                })
                break
            default:
                this.paymentInfoForm = {
                    paymentAccount: null, // 银行卡号 or 支付宝号
                    confirmPaymentAccount: null, // 银行卡号 or 支付宝号
                    realName: null, // 用户实名
                    cardInfo: item,
                    ...fromData,
                    paymentType: fromData.buyerPayType ? String(fromData.buyerPayType) : '1'
                }
                // 取消原因
                if (this.paymentInfoForm.cardInfo.content?.formField) {
                    const radioItem = this.paymentInfoForm.cardInfo.content?.formField.find(el => el.dataType === 'SINGLE' && el.name === '取消原因')
                    this.paymentInfoForm.cancelReason = radioItem
                }
                this.regularState = true
                break
            }
        },
        // 固定卡片提交
        regularFromSubmit (formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.loadingBt = true
                    const data = this.paymentInfoForm
                    switch (this.paymentInfoForm.isBuy) {
                    case 1:
                        const newPaymentInfoForm = Object.fromEntries(Object.entries(data).filter(([key]) => !['paymentAccountOne', 'paymentAccountTwo', 'realNameOne'].includes(key)))
                        const parData = {
                            ...newPaymentInfoForm,
                            realName: data.realNameOne,
                            paymentAccount: data.paymentAccountOne
                        }
                        // 取消交易家提交
                        this.$api.workorderBuyerSubmitPaymentAccount({ ...parData }).then(res => {
                            if (res.success) {
                                this.loadingBt = false
                                this.regularState = false
                                this.$message.success('操作成功')
                            } else {
                                this.$message.error(res.info)
                                this.loadingBt = false
                            }
                        })
                        break
                    case 2:
                        // 卖家账户校验
                        this.$api.workorderCheckPaymentAccount(data).then(res => {
                            if (res.success) {
                                this.loadingBt = false
                                this.regularState = false
                                this.$message.success('操作成功')
                            } else {
                                this.$message.error(res.info)
                                this.loadingBt = false
                            }
                        })
                        break
                    case 4:
                        const newPaymentInfoForm1 = Object.fromEntries(Object.entries(data).filter(([key]) => !['paymentAccountOne', 'paymentAccountTwo', 'realNameOne'].includes(key)))
                        // 账户异常流程
                        const par1 = {
                            ...newPaymentInfoForm1,
                            idToken: data.idToken,
                            orderId: data.orderId,
                            realName: data.realNameOne,
                            paymentAccount: data.paymentAccountOne
                        }
                        this.$api.workorderPayAccountBind(par1).then(res => {
                            if (res.success) {
                                this.loadingBt = false
                                this.regularState = false
                                this.$message.success('操作成功')
                            } else {
                                this.$message.error(res.info)
                                this.loadingBt = false
                            }
                        })
                        break
                    case 5:
                    case 6:
                    case 7:
                        // 中介取消交易双方提交
                        this.$api.getCancelPaymentInformationAgency(data).then(res => {
                            if (res.success) {
                                this.loadingBt = false
                                this.regularState = false
                                this.$message.success('操作成功')
                            } else {
                                this.$message.error(res.info)
                                this.loadingBt = false
                            }
                        })
                        break
                    default:
                        // 账户异常流程
                        const par = {
                            ...data,
                            idToken: data.idToken,
                            orderId: data.orderId,
                            paymentAccount: data.paymentAccount,
                            realName: data.realName
                        }
                        this.$api.workorderPayAccountBind(par).then(res => {
                            if (res.success) {
                                this.loadingBt = false
                                this.regularState = false
                                this.$message.success('操作成功')
                            } else {
                                this.$message.error(res.info)
                                this.loadingBt = false
                            }
                        })
                        break
                    }
                } else {
                    console.warn('error submit!!')
                    return false
                }
            })
        },
        // 清空指定字段的校验
        clearFrom (formName) {
            this.paymentInfoForm.paymentAccount = null
            this.paymentInfoForm.confirmPaymentAccount = null
            this.$refs[formName].clearValidate(['paymentAccount', 'confirmPaymentAccount'])
        },
        // 回收弹窗显示
        recyclingPayMsgShow (_, item) {
            this.recyclingPayMsgData = JSON.parse(JSON.stringify(item.content.content))
            this.$api.quoteLatestPrice({ id: this.recyclingPayMsgData.quoteId }).then(res => {
                if (res.success) {
                    this.recyclingPayMsgData = { ...this.recyclingPayMsgData, ...res.data }
                    this.recyclingPayMsgModel = true
                } else {
                    this.$message.error(res.info)
                }
            })
        },
        // 回收确认
        submitRecyclingPay () {
            const data = {
                id: this.recyclingPayMsgData.quoteId
            }
            this.$api.quotedAgree(data).then(res => {
                if (res.success) {
                    this.recyclingPayMsgModel = false
                    this.$message.success('操作成功')
                } else {
                    this.recyclingPayMsgModel = false
                    this.$message.error(res.info)
                }
            })
        },
        // 显示评价
        evaluateShow () {
            if (this.evaluateModel) { return }
            this.$api.questionnaireConsultIsEvaluate({ csId: this.customerInfo.targetId }).then(res => {
                if (res.success) {
                    this.evaluateModel = true
                    this.evaluateIconIndex = null
                    this.evaluateTextIndex = null
                    this.evaluateState = false
                    this.evaluateInput = ''
                    this.evaluateSubmitState = false
                    this.evaluateSubmitNum = 3
                } else {
                    this.$message.error('抱歉！该评价您已填写')
                }
            })
        },
        // 选择满意度
        evaluateIconClick (_, i) {
            this.evaluateIconIndex = i
            this.evaluateState = true
        },
        // 解决问题
        evaluateTextClick (_, i) {
            this.evaluateTextIndex = i
            this.evaluateState = true
        },
        // 提交评价
        evaluateSubmit () {
            if (!this.evaluateState) {
                this.$message.error('请对本次客服的服务进行评价')
                return
            }
            const data = {
                csId: this.customerInfo.targetId,
                text: this.evaluateInput
            }
            if (this.evaluateIconIndex != null) {
                data.satisfaction = this.evaluateIconIndex + 1 // 满意度1-5
            }
            if (this.evaluateTextIndex != null) {
                data.solved = !this.evaluateTextIndex // 是否解决
            }
            this.$api.questionnaireConsultSubmit(data).then(res => {
                if (res.success) {
                    this.evaluateSubmitState = true
                    this.timer = setInterval(() => {
                        --this.evaluateSubmitNum
                        if (this.evaluateSubmitNum == 0) {
                            clearTimeout(this.timer)
                            this.evaluateModel = false
                        }
                    }, 1000)
                } else {
                    this.$message.error(res.info)
                }
            })
        },
        /** @投诉工单评价 **/
         // 显示评价
         complaintEvaluateShow (params) {
            if (this.evaluateModel) { return }
            this.complaintId = params.complainId
            this.callback = params.callback // 保存回调函数
            this.$api.getComplaintDetail({ id: params.complainId }).then(res => {
                if (!res.success) {
                    return this.$message.error(res.info)
                }
                if (res.data.evaluateScore !== 0) {
                    return this.$message.error('抱歉！该评价您已填写')
                }
                this.complaintEvaluateModel = true
                this.complaintEvaluateIconIndex = null
                this.complaintEvaluateTextIndex = null
                this.complaintEvaluateState = false
                this.complaintEvaluateInput = ''
                this.complaintEvaluateSubmitNum = 3
                this.complaintEvaluateSubmitState = false
            })
        },
        // 选择满意度
        complaintEvaluateIconClick (_, i) {
            this.complaintEvaluateIconIndex = i
            this.complaintEvaluateState = true
        },
        // 解决问题
        complaintEvaluateTextClick (_, i) {
            this.complaintEvaluateTextIndex = i
            this.complaintEvaluateState = true
        },
        // 提交评价
        complaintEvaluateSubmit () {
            if (!this.complaintEvaluateState) {
                this.$message.error('请对本次客服的服务进行评价')
                return
            }
            const data = {
                id: this.complaintId,
            }
            if (this.complaintEvaluateIconIndex != null) {
                data.evaluateScore = this.complaintEvaluateIconIndex + 1 // 满意度1-5
            }
            if (this.complaintEvaluateTextIndex != null) {
                data.solveProblem = !this.complaintEvaluateTextIndex // 是否解决
            }
            this.$api.submitComplaintEvaluate(data).then(res => {
                if (res.success) {
                    this.complaintEvaluateSubmitState = true
                    this.complaintEvaluateSubmitNum = 3
                    this.timer = setInterval(() => {
                        --this.complaintEvaluateSubmitNum
                        if (this.complaintEvaluateSubmitNum <= 0) {
                            clearInterval(this.timer)
                            this.complaintEvaluateModel = false
                        }
                    }, 1000)
                    if (this.callback) {
                        this.callback()
                    }
                } else {
                    this.$message.error(res.info)
                }
            })
        },
        removeAllSpaces (str) {
            return str.replace(/\s/g, '')
        },
        // 下载app提示弹窗
        downloadAppTip (val) {
            this.downloadInfo = val
            this.downloadModel = true
        },
        // 查看收款账户
        getReceivingAccountModel (val) {
            this.receivingAccountModel = true
            this.receivingAccountModelData = val
        },
        // 复制
        copyPayNum (val) {
            copyToClip(val, '已复制')
            this.receivingAccountModel = false
        },
        // 点击评价图标
        afterSalesIconClick (_, index) {
            this.evaluateIconIndexs = index
            this.selectedTags = [] // 清空已选标签
        },

        // 选择标签
        handleTagSelect (tag) {
            const index = this.selectedTags.findIndex(item => item.id === tag.id)
            if (index > -1) {
                this.selectedTags.splice(index, 1)
            } else {
                this.selectedTags.push(tag)
            }
        },

        // 提交评价
        async afterSalesEvaluateSubmit () {
            try {
                const submitData = {
                    optionGroupId: this.evaluateIconIndexs + 1,
                    optionIds: this.selectedTags.map(tag => tag.id),
                    workOrderNo: this.workOrderNo,
                    text: this.evaluateContent
                }

                // 调用提交评价接口
                const res = await this.$api.afterSalesEvaluationSubmitAPI(submitData)

                if (!res.success) {
                    this.$message.error(res.info || '提交评价失败')
                    return
                }

                this.$message.success('评价提交成功')
                this.afterSalesSubmitState = true
                // 调用父组件传入的回调函数
                if (this.callback) {
                    this.callback()
                }
                this.startCountDown()
            } catch (error) {
                this.$message.error('提交评价失败，请稍后重试')
                console.error('评价提交错误：', error)
            }
        },

        // 开始倒计时
        startCountDown () {
            if (this.timer) {
                clearInterval(this.timer)
            }
            this.evaluateSubmitNum = 3 // 重置倒计时数字
            this.timer = setInterval(() => {
                if (this.evaluateSubmitNum <= 1) {
                    clearInterval(this.timer)
                    this.afterSalesEvaluationModel = false
                    this.afterSalesSubmitState = false
                    this.evaluateSubmitNum = 3
                    this.evaluateIconIndexs = -1
                    this.selectedTags = []
                } else {
                    this.evaluateSubmitNum--
                }
            }, 1000)
        }
    }
}
// 节流
function throttle (func, wait) {
    let timeout = null
    let lastExecution = 0
    return function (...args) {
        const context = this
        const now = Date.now()
        if (lastExecution && now - lastExecution < wait) {
            clearTimeout(timeout)
            timeout = setTimeout(() => {
                lastExecution = now
                func.apply(context, args)
            }, wait - (now - lastExecution))
        } else {
            lastExecution = now
            func.apply(context, args)
        }
    }
}
